import NavBar from '@/components/Nav.vue';

import enums from '@/configs/enums.js';

export default {
    name: 'MarketPage',
    components: {
        NavBar,
    },
    data() {
        return {
            selectedCategory: 0,
            categories: [],
            state: '',
            states: enums.productState,
            page: 1,
            more: true,
            loading: false,
            products: []
        }
    },
    created() {
        this.$http.get('category').then(result => {
            this.categories = result.data.categories;
        })
        this.getProductList();
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        getProductList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                let params = {state: this.state, page: this.page};
                if (this.selectedCategory) {
                    params.category = this.selectedCategory;
                }
                this.$http.get('product', {params: params}).then(result => {
                    this.page++;
                    this.loading = false;
                    this.more = result.data.more;
                    this.products = this.products.concat(result.data.products);
                })
            }
        },
        selectCategory(id) {
            this.selectedCategory = id;
            this.page = 1;
            this.more = true;
            this.loading = false;
            this.products = [];
            this.getProductList();
        },
        selectState(value) {
            this.state = value;
            this.loading = false;
            this.page = 1;
            this.more = true;
            this.products = [];
            this.getProductList();
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getProductList();
            }
        }
    }
}